"use client"

import CartTotals from "@modules/common/components/cart-totals"
import DiscountCode from "@modules/checkout/components/discount-code"
import ExpressCheckout from "@modules/checkout/components/express-checkout"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { HttpTypes } from "@medusajs/types"

type SummaryProps = {
  cart: HttpTypes.StoreCart
}

const FREE_SHIPPING_FROM = 29

function getCheckoutStep(cart: HttpTypes.StoreCart) {
  if (!cart?.shipping_address?.address_1 || !cart.email) {
    return "address"
  } else if (cart?.shipping_methods?.length === 0) {
    return "delivery"
  } else {
    return "payment"
  }
}

const Summary = ({ cart }: SummaryProps) => {
  const step = getCheckoutStep(cart)
  const subtotal = cart.item_subtotal ?? 0
  const remaining = FREE_SHIPPING_FROM - subtotal

  return (
    <div className="flex flex-col gap-y-4">
      {remaining <= 0 ? (
        <p className="text-sm text-amz-green">
          <span className="font-bold">Tu pedido reune los requisitos para el envio GRATIS</span>{" "}
          con Packlink. Selecciona envio estandar al tramitar el pedido.
        </p>
      ) : (
        <p className="text-sm">
          Anade{" "}
          <span className="font-bold text-amz-price">
            {remaining.toLocaleString("es-ES", { style: "currency", currency: cart.currency_code.toUpperCase() })}
          </span>{" "}
          para conseguir envio GRATIS.
        </p>
      )}
      <CartTotals totals={cart} />
      <LocalizedClientLink
        href={"/checkout?step=" + step}
        data-testid="checkout-button"
        className="amz-btn-yellow w-full"
      >
        Tramitar pedido
      </LocalizedClientLink>
      <div className="flex items-center gap-x-2 text-xs text-[#565959]">
        <span className="h-px flex-1 bg-[#e7e7e7]" />
        o paga en un paso, sin registrarte
        <span className="h-px flex-1 bg-[#e7e7e7]" />
      </div>
      <ExpressCheckout
        source={{ type: "cart", cartId: cart.id }}
        amount={Math.round((cart.total ?? 0) * 100)}
        currency={cart.currency_code}
        renderQuickBuy={(open, disabled) => (
          <button
            onClick={open}
            disabled={disabled}
            className="amz-btn-orange w-full"
            data-testid="cart-quick-buy-button"
          >
            Compra rapida: Bizum o tarjeta
          </button>
        )}
      />
      <DiscountCode cart={cart} />
    </div>
  )
}

export default Summary
